import {Component, Input, OnInit} from '@angular/core';
import {BaseClass} from 'src/app/shared/classes/base';
import {ToastController} from '@ionic/angular';
import {TranslationService} from 'src/app/shared/services/translation.service';
import {FreeEvaluationReport} from 'src/app/final-report/_interfaces/final-report.interface';
import {ProcessConfig, QuestionConfig} from 'src/app/shared/interfaces/process-config.interface';
import {ConfigService} from 'src/app/shared/services/multi-clients/config.service';

@Component({
    selector: 'app-free-evaluation-report',
    templateUrl: './free-evaluation-report.component.html',
    styleUrls: ['./free-evaluation-report.component.scss']
})
export class FreeEvaluationReportComponent extends BaseClass implements OnInit {

    @Input() readonly titleKey: string = 'dashboard.freeEvaluation';
    @Input() readonly processConfig: ProcessConfig;
    @Input() readonly evaluations: Array<FreeEvaluationReport>;
    @Input() readonly showMoreLess: Boolean;

    public scrollEnabled: boolean;
    public selectedLanguage: string = 'en-US';
    public allQuestionsQtd: number;
    public columnSize = 2;
    public headerWidth: { width: string } = null;

    show =
        {
            showQuestions: Array<boolean>(),
            showTitles: false,
            showName: false
        };

    constructor(
        protected _toastController: ToastController,
        protected _translationService: TranslationService,
        private _configService: ConfigService
    ) {
        super(_toastController, _translationService);
        this.selectedLanguage = this._translationService.getSelectedLanguage();
    }

    public ngOnInit(): void {
        this.scrollEnabled = this._configService.settings.features.scrollSeeEvalOnManagerEvalEnabled;
        this.allQuestionsQtd = this.getQuestions(this.processConfig).length;
        this.headerWidth = this.getCardHeaderStyles();
    }

    public getQuestions(processConfig: ProcessConfig): Array<QuestionConfig> {
        if (processConfig && processConfig.questionsGroups && processConfig.questionsGroups.length > 0) {
            let questions: Array<QuestionConfig> = [];

            processConfig.questionsGroups.forEach(group => {
                questions = [...questions, ...group.questions];
            });
            return questions;
        }
        return processConfig && processConfig.questions ? processConfig.questions : [];
    }

    public isNumber(concept: any) {
        return isNaN(concept);
    }

    public getIndex(concept: string) {
        return parseInt(concept) - 1;
    }

    public getCardHeaderStyles(isManager: boolean = false) {
        if (this.scrollEnabled && this.allQuestionsQtd && this.allQuestionsQtd > 0) {
            if ((this.allQuestionsQtd * 200) + 275 > 960)
                return {width: (this.allQuestionsQtd * 200) + 275 + 'px'};
            return null;
        } else {
            return null;
        }
    }

}
